import { type ActionThunk, createStore, type Store } from 'react-sweet-state';

import { EMPTY_CONVERSATION_ID } from '@atlassian/conversation-assistant-store/controllers/chat';
import {
	CHAT_STORE_STATUS,
	DEFAULT_CONVERSATION_PAGINATION,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import type { WidgetChatStorePrivateState } from './types';

const initialState: WidgetChatStorePrivateState = {
	conversations: {
		EMPTY_CONVERSATION_ID: {
			id: EMPTY_CONVERSATION_ID,
			messages: [],
			name: '',
			status: CHAT_STORE_STATUS.idle,
			traces: [],
			timeCreated: new Date().toISOString(),
		},
	},
	currentConversationId: EMPTY_CONVERSATION_ID,
	conversationPagination: { ...DEFAULT_CONVERSATION_PAGINATION },
	twilioClient: null,
	twilioClientTokenMeta: null,
	twilioConversationsWithMetadata: {},
	twilioTokenRefreshCleanup: null,
	liveChatSubscriptionId: null,
	liveChatConversationAri: null,
	csmLiveChatSubscriptionId: null,
	hasInitiatedLiveChat: false,
	isInitializingTwilioConversation: false,
	twilioAgentsTyping: [],
	twilioConversationAgentJoined: {},
	directLiveChatNoAgentAvailable: false,
	chatMode: null,
	supportTeamFallbackMessage: null,
	twilioBootstrapFatalError: null,
};

export const createChatStore = <
	T extends Record<string, ActionThunk<WidgetChatStorePrivateState, T>>,
>(
	actions: T,
): Store<WidgetChatStorePrivateState, T> => {
	return createStore({
		name: 'CsmChatSimulatorStore',
		initialState,
		actions,
	});
};
